import React, { useEffect, useState } from "react";

import label from "../../labels/administration_en.json";

import CutOff from "../../../interviewProcess/components/cutOff/cutOff";
import RecommendationCutOff from "../../../interviewProcess/components/cutOff/recommendationCutOff";

const CutOffReport = () => {

  const [stepName, setName] = useState("cutoff");


  return (
    <div className="commonContentArea">
      <h5 className="labelMargin"> {label.CutOffReport} </h5>
      <div
        className="tab-content border border-light myTabContent"
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">

          <li className="nav-item" key="1">
            <a
              href="#"
              className={
                stepName === "cutoff"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="cutoff"
              id="cutoff-tab"
              onClick={() => setName("cutoff")}
              data-toggle="tab"
              role="tab"
              aria-controls="cutoff"
              aria-selected="false"
            >
              <span>Cut Off</span>
            </a>
          </li>

          <li className="nav-item" key="2">
            <a
              href="#"
              className={
                stepName === "recommendation"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="recommendation"
              id="recommendation-tab"
              onClick={() => setName("recommendation")}
              data-toggle="tab"
              role="tab"
              aria-controls="recommendation"
              aria-selected="false"
            >
              <span>Recommendation Cut Off</span>
            </a>
          </li>
        </ul>

        <div className="tab-content border border-light" id="myTabContent">

          <div
            className={
              stepName === "cutoff"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="cutoff"
            role="tabpanel"
            aria-labelledby="cutoff-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <CutOff key={stepName} />
              </div>
            </div>
          </div>

          <div
            className={
              stepName === "recommendation"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="recommendation"
            role="tabpanel"
            aria-labelledby="recommendation-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <RecommendationCutOff key={stepName} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CutOffReport;